export default __webpack_public_path__ + "static/media/review_eddie.6053770a.svg";